import styled from 'styled-components'
import { blue, hoverBlue } from '../../assets/ui/colors';

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Button = styled.div`
  display: flex;
  justify-content: center;
  width: 45%;
  padding: 48px 24px;
  cursor: pointer;
  border-radius: 6px;
  color: white;
  font-size: 28px;
  text-align: center;
  background: ${hoverBlue};
  transition: 0.5s;
  :hover {
    background: ${blue};
  }
  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 24px;
  }
`;
